import { Routes, Route } from "react-router-dom";

import Theme from "../Layout/Superadmin/Themes/Theme";
import AddTheme from "../Layout/Superadmin/Themes/AddTheme";
import Edittheme from "../Layout/Superadmin/Themes/EditTheme";
import Company from "../Layout/Superadmin/Company/Company";
import Dashbord from "../Layout/Admin/Admin_dashboard/Dashboard";
import Basket from "../Layout/Admin/Admin_basket/Basket";
import AddBasket from "../Layout/Admin/Admin_basket/Addbasket";
import Viewbasketdetail from "../Layout/Admin/Admin_basket/Viewbasketdetail";
import Editbasket from "../Layout/Admin/Admin_basket/Editbasket";
import AddStock from "../Layout/Admin/Admin_basket/AddStock";
import BasketStockPublish from "../Layout/Admin/Admin_basket/BasketStockPublish";
import BasketPurchaseHistory from "../Layout/Admin/Admin_basket/BasketPurchaseHistory";
import AllBasketHistory from "../Layout/Admin/Admin_basket/AllBasketHistory";
import EditStock from "../Layout/Admin/Admin_basket/EditStock";
import Client from "../Layout/Admin/Admin_client/Client";
import Freeclient from "../Layout/Admin/Admin_client/Freeclient";
import AddUser from "../Layout/Admin/Admin_client/AddUser";
import EditClient from "../Layout/Admin/Admin_client/EditClient";
import Viewclientdetail from "../Layout/Admin/Admin_client/Viewclient";
import Editfreeclient from "../Layout/Admin/Admin_client/Editfreeclient";
import ClientDeleteHistory from "../Layout/Admin/Admin_client/ClientDeleteHistory";
import ClientSignaldetail from "../Layout/Admin/Admin_client/ClientSignaldetail";
import ClientRequest from "../Layout/Admin/Admin_client/ClientRequest/ClientRequest";
import Faq from "../Layout/Admin/Admin_faq/Faq";
import Perform from "../Layout/Admin/Admin_perfom/Perfom";
import Service from "../Layout/Admin/Admin_service/Service.s";
import Banner from "../Layout/Admin/Banner/Banner";
import Blogs from "../Layout/Admin/Bloags/Blogs";
import Addblogs from "../Layout/Admin/Bloags/Addblogs";
import Updateblogs from "../Layout/Admin/Bloags/Updateblogs";
import Viewblog from "../Layout/Admin/Bloags/Viewblog";
import Category from "../Layout/Admin/Category/Category";
import Profile from "../Layout/Admin/Admin_profile/Profile";
import Signal from "../Layout/Admin/Admin_signal/Signal";
import AddSignal from "../Layout/Admin/Admin_signal/AddSignal";
import Signaldetail from "../Layout/Admin/Admin_signal/Signaldetail";
import Closesignal from "../Layout/Admin/Admin_signal/Closesignal";
import MCXSignal from "../Layout/Admin/Admin_signal/MCXSignal";
import MCXClosesignal from "../Layout/Admin/Admin_signal/MCXClosesignal";
import AddMCXSignal from "../Layout/Admin/Admin_signal/AddMCXSignal";
import Staff from "../Layout/Admin/Admin_staff/Staff";
import AddStaff from "../Layout/Admin/Admin_staff/AddStaff";
import Update from "../Layout/Admin/Admin_staff/Update";
import Staffpermission from "../Layout/Admin/Admin_staff/Staffpermission";
import Generalsettings from "../Layout/Admin/BasicSetting/Generalsettings";
// import Apiinfo from "../Layout/Admin/BasicSetting/Apiinfo";
import Payementgateway from "../Layout/Admin/BasicSetting/Payementgateway";
import Emailsettings from "../Layout/Admin/BasicSetting/Emailsettings";
import Emailtemplate from "../Layout/Admin/BasicSetting/Emailtemplate";
import ReferAndEarn from "../Layout/Admin/BasicSetting/ReferAndEarn";
import Autosquareoff from "../Layout/Admin/BasicSetting/Autosquareoff";
import UpdateOffer from "../Layout/Admin/BasicSetting/UpdateOffer";
import Bankdetail from "../Layout/Admin/BasicSetting/BankDetaildata/Bankdetail";
import Addbankdetail from "../Layout/Admin/BasicSetting/BankDetaildata/Addbankdetail";
import Updatebankdetail from "../Layout/Admin/BasicSetting/BankDetaildata/Updatebankdetail";
import QRDetails from "../Layout/Admin/BasicSetting/QRDetails/QRDetails";
import Help from "../Layout/Admin/Help_center/Help";
import PaymentRequest from "../Layout/Admin/PaymentRequest/PaymentRequest";
import FreetrialStatus from "../Layout/Admin/Freetrialstatus/FreetrialStatus";
import Message from "../Layout/Admin/Broadcast/Message";
import Addbroadcast from "../Layout/Admin/Broadcast/Addbroadcast";
import Updatebroadcast from "../Layout/Admin/Broadcast/Updatebroadcast";
import BroadcastRequest from "../Layout/Admin/Broadcast/BroadcastRequest";
import Planexpiry from "../Layout/Admin/PlanExpiry/Planexpiry";
import Planexpirymonth from "../Layout/Admin/PlanExpiryMonth/Planexpirymonth";
import Notificationlist from "../Layout/Admin/Notification/Notificationlist";
import Stock from "../Layout/Admin/Stock/Stock";
import Plan from "../Layout/Admin/Plans/Plan";
import Addplan from "../Layout/Admin/Plans/Addplan";
import Editplan from "../Layout/Admin/Plans/Editplan";
import HomeBannerUpdate from "../Layout/Admin/BasicSetting/HomeBannerUpdate";
import News from "../Layout/Admin/News/News";
import Addnews from "../Layout/Admin/News/Addnews";
import Updatenews from "../Layout/Admin/News/Updatenews";
import Condition from "../Layout/Admin/Termscondition/Condition";
import Updatecondition from "../Layout/Admin/Termscondition/Updatecondition";
import PaymentHistory from "../Layout/Admin/Payment_history/Paymenthistory";

import Coupon from "../Layout/Admin/Coupon/Coupon";
import Addcoupon from "../Layout/Admin/Coupon/Addcoupon";
import Updatecoupon from "../Layout/Admin/Coupon/Updatecoupon";
import Apiinfo from "../Layout/Admin/BasicSetting/Apiinfo";
import Stockrating from "../Layout/Admin/Stockrating/Stockrating";
import UpdateRating from "../Layout/Admin/Stockrating/UpdateRating";
import AddRating from "../Layout/Admin/Stockrating/AddRating";
import ClientOrderlist from "../Layout/Admin/ClientOrderlist/ClientOrderlist";
import CartList from "../Layout/Admin/Admin_client/CartList";
import Changepass from "../Layout/Auth/Changepass";
import ReferAndEarnlist from "../Layout/Admin/BasicSetting/ReferAndEarnlist";
import PlanExpirymonthDetail from "../Layout/Admin/PlanExpiryMonth/PlanExpirymonthDetail";
import MultipleSignal from "../Layout/Admin/Admin_signal/MultipleSignal";
import MultipleSignaldetail from "../Layout/Admin/Admin_signal/MultipleSignaldetail";
import PopupDescription from "../Layout/Admin/BasicSetting/PopupDescription";
import SmsTemplate from "../Layout/Admin/BasicSetting/SmsTemplate";
import SMSProvider from "../Layout/Admin/BasicSetting/SMSProvider";
import EditBasketStockPublish from "../Layout/Admin/Admin_basket/EditBasketStockPublish";
import Tickets from "../Layout/Admin/Tickets/Tickets";
import ViewTicket from "../Layout/Admin/Tickets/ViewTicket";
import AddMailToClient from "../Layout/Admin/SendMailToClient/AddMailToClient";
import ViewMail from "../Layout/Admin/SendMailToClient/ViewMail";
import UpdateMail from "../Layout/Admin/SendMailToClient/UpdateMail";
import UtmSource from "../Layout/Admin/UTM_Source/Utmource";
import TodayExpirydata from "../Layout/Admin/Admin_dashboard/TodayExpirydata";
import YesterdayExpirydata from "../Layout/Admin/Admin_dashboard/YesterdayExpirydata";
import TommarrowExpirydata from "../Layout/Admin/Admin_dashboard/TommarrowExpirydata";
import CurrentMonthfreeTrial from "../Layout/Admin/CurrentMonthfreeTrial.jsx/CurrentMonthfreeTrial";
import CurrentMonthFreeTrialDetail from "../Layout/Admin/CurrentMonthfreeTrial.jsx/CurrentMonthFreeTrialDetail";
import PrivateRoute from "./PrivateRoute.routes";
import Clover from "../Layout/Admin/Clover/Clover";
import Rating from "../Layout/Admin/Rating/Rating";
import ActiveBanner from "../Layout/Admin/Banner/ActiveBanner";
import NotificationTemplate from "../Layout/Admin/BasicSetting/NotificationTemplate";
import Scannerlist from "../Layout/Admin/Scanner/Scannerlist";
import ScannerOrder from "../Layout/Admin/Scanner/ScannerOrder";
import ScannerView from "../Layout/Admin/Scanner/ScannerView";
import Complaindata from "../Layout/Admin/ComplaintsOverview/Complaindata";
import Grievancedata from "../Layout/Admin/ComplaintsOverview/Grievancedata";
import Regulatory from "../Layout/Admin/ComplaintsOverview/Regulatory";
import ActiveClientsdatewise from "../Layout/Admin/Active_Client_Datewise/ActiveClientsDateWise.jsx";
import ActiveClientsByDateRange from "../Layout/Admin/Active_Client_Datewise/ActiveClientByDateRange.jsx";

export default function App() {
  return (
    <Routes>
      <Route element={<PrivateRoute allowedRoles={["ADMIN"]} />}>
        <Route path="/themes" element={<Theme />} />
        <Route path="/add-theme" element={<AddTheme />} />
        <Route path="/edit-theme/:id" element={<Edittheme />} />
        <Route path="/dashboard" element={<Dashbord />} />
        <Route path="/company" element={<Company />} />

        <Route path="/profile" element={<Profile />} />

        <Route path="/basket" element={<Basket />} />
        <Route path="/addbasket" element={<AddBasket />} />
        <Route path="/viewdetail/:id" element={<Viewbasketdetail />} />
        <Route path="/basket/editbasket/:id" element={<Editbasket />} />
        <Route path="/addstock/:id" element={<AddStock />} />
        <Route
          path="/basket/basketstockpublish"
          element={<BasketStockPublish />}
        />
        <Route
          path="/basket/basketstockpublish/:id"
          element={<EditBasketStockPublish />}
        />
        <Route
          path="/basket-purchase-history/:id"
          element={<BasketPurchaseHistory />}
        />
        <Route path="/purchasebaskethistory" element={<AllBasketHistory />} />
        <Route path="/editstock" element={<EditStock />} />

        <Route path="/stock" element={<Stock />} />

        <Route path="/client" element={<Client />} />
        <Route path="/freeclient" element={<Freeclient />} />
        <Route path="/addclient" element={<AddUser />} />
        <Route path="/client/updateclient/:id" element={<EditClient />} />
        <Route path="/client/clientdetail/:id" element={<Viewclientdetail />} />
        <Route path="/editfreeclient/:id" element={<Editfreeclient />} />
        <Route path="/clientdeletehistory" element={<ClientDeleteHistory />} />
        <Route
          path="/clientsignaldetail/:id"
          element={<ClientSignaldetail />}
        />
        <Route path="/clientrequest" element={<ClientRequest />} />
        <Route path="/cartlist/:id" element={<CartList />} />

        <Route path="/faq" element={<Faq />} />
        <Route path="/paymenthistory" element={<PaymentHistory />} />

        <Route path="/perfom" element={<Perform />} />
        <Route path="/service" element={<Service />} />

        <Route path="/banner" element={<Banner />} />
        <Route path="/activebanner" element={<ActiveBanner />} />

        <Route path="/clover" element={<Clover />} />
        <Route path="/rating-list" element={<Rating />} />

        <Route path="/blogs" element={<Blogs />} />
        <Route path="/addblogs" element={<Addblogs />} />
        <Route path="/updatebolgs" element={<Updateblogs />} />
        <Route path="/viewblog" element={<Viewblog />} />

        <Route path="/category" element={<Category />} />

        <Route path="/signal" element={<Signal />} />
        <Route path="/addsignal" element={<AddSignal />} />
        <Route path="/signaldetaile/:id" element={<Signaldetail />} />
        <Route path="/closesignal" element={<Closesignal />} />
        <Route path="/mcxsignal" element={<MCXSignal />} />
        <Route path="/mcxclosesignal" element={<MCXClosesignal />} />
        <Route path="/addmcxsignal" element={<AddMCXSignal />} />
        <Route path="/multiplesignal" element={<MultipleSignal />} />
        <Route
          path="/multipleSignaldetail/:id"
          element={<MultipleSignaldetail />}
        />

        <Route path="/staff" element={<Staff />} />
        <Route path="/addstaff" element={<AddStaff />} />
        <Route path="/staff/updatestaff/:id" element={<Update />} />
        <Route
          path="/staff/staffpermission/:id"
          element={<Staffpermission />}
        />

        <Route path="/generalsettings" element={<Generalsettings />} />
        <Route path="/Apiinfo" element={<Apiinfo />} />
        <Route path="/paymentgeteway" element={<Payementgateway />} />
        <Route path="/emailsetting" element={<Emailsettings />} />
        <Route path="/smstemplate" element={<SmsTemplate />} />
        <Route path="/smsprovider" element={<SMSProvider />} />
        <Route path="/emailtemplate" element={<Emailtemplate />} />
        <Route path="/referandearn" element={<ReferAndEarn />} />
        <Route path="/autosquareoff" element={<Autosquareoff />} />
        <Route path="/updateoffer" element={<UpdateOffer />} />
        <Route path="/homebannerupdate" element={<HomeBannerUpdate />} />
        <Route path="/popupdescription" element={<PopupDescription />} />
        <Route
          path="/notification-template"
          element={<NotificationTemplate />}
        />

        <Route path="/bankdetail" element={<Bankdetail />} />
        <Route path="/addbankdetail" element={<Addbankdetail />} />
        <Route path="/updatebankdetail/:id" element={<Updatebankdetail />} />

        <Route path="/QRdetails" element={<QRDetails />} />

        <Route path="/changepass" element={<Changepass />} />
        <Route path="/help" element={<Help />} />
        <Route path="/paymentrequest" element={<PaymentRequest />} />

        <Route path="/freetrialstatus" element={<FreetrialStatus />} />

        <Route path="/plan" element={<Plan />} />
        <Route path="/addplan" element={<Addplan />} />
        <Route path="/plan/editplan/:id" element={<Editplan />} />

        <Route path="/message" element={<Message />} />
        <Route path="/addbroadcast" element={<Addbroadcast />} />
        <Route path="/updatebroadcast" element={<Updatebroadcast />} />
        <Route path="/broadcastrequest" element={<BroadcastRequest />} />

        <Route path="/planexpiry" element={<Planexpiry />} />
        <Route path="/planexpirymonth" element={<Planexpirymonth />} />
        <Route
          path="/planExpirymonthDetail"
          element={<PlanExpirymonthDetail />}
        />

        <Route path="/notificationlist" element={<Notificationlist />} />

        <Route path="/profile" element={<Profile />} />

        <Route path="/news" element={<News />} />
        <Route path="/addnews" element={<Addnews />} />
        <Route path="/updatenews" element={<Updatenews />} />

        <Route path="/coupon" element={<Coupon />} />
        <Route path="/addcoupon" element={<Addcoupon />} />
        <Route path="/coupon/updatecoupon/:id" element={<Updatecoupon />} />

        <Route path="/termsandcondtion" element={<Condition />} />
        <Route path="/updatecondition" element={<Updatecondition />} />

        <Route path="/stockrating" element={<Stockrating />} />
        <Route
          path="/stockrating/updaterating/:id"
          element={<UpdateRating />}
        />
        <Route path="/addrating" element={<AddRating />} />

        <Route path="/orderlist" element={<ClientOrderlist />} />
        <Route path="/referAndEarnlist" element={<ReferAndEarnlist />} />

        <Route path="/tickets" element={<Tickets />} />
        <Route path="/viewticket/:id" element={<ViewTicket />} />

        <Route path="/addmail-to-client" element={<AddMailToClient />} />
        <Route path="/view-mail" element={<ViewMail />} />
        <Route path="/update-mail" element={<UpdateMail />} />

        <Route path="/utm-source" element={<UtmSource />} />

        <Route path="/todayExpiry-data" element={<TodayExpirydata />} />
        <Route path="/yesterdayExpiry-data" element={<YesterdayExpirydata />} />
        <Route path="/tomorrowExpiry-data" element={<TommarrowExpirydata />} />

        <Route
          path="/CurrentMonth-freeTrial"
          element={<CurrentMonthfreeTrial />}
        />
        <Route
          path="/freeTrial-detail"
          element={<CurrentMonthFreeTrialDetail />}
        />

        <Route path="/scanner-list" element={<Scannerlist />} />
        <Route path="/scanner-Order" element={<ScannerOrder />} />
        <Route path="/scanner-View" element={<ScannerView />} />

        <Route path="/complain" element={<Complaindata />} />
        <Route path="/grievance" element={<Grievancedata />} />
        <Route path="/regulatory" element={<Regulatory />} />
        <Route
          path="/active-clients-date-wise"
          element={<ActiveClientsdatewise />}
        />
        <Route
          path="/active-clients-by-date-range"
          element={<ActiveClientsByDateRange />}
        />
      </Route>
    </Routes>
  );
}
